import React, { useMemo, useContext } from 'react'
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import GraphTable from '../mechanisms/graphtable';
import { currencyPrefix } from '../single-card';
import { formatCurrency } from '../functions';
import { aggregateData } from '../functions';
import DashView from '../mechanisms/dashview';
import { DashboardContext } from '../mechanisms/card';
import dayjs from 'dayjs'
import { convert_seconds } from '../../Dash/HistoricDash/graphs/charts';

const ClosedOpportunitiesDashboard = ({ data }) => {

    const { type } = useContext(DashboardContext)

    const graph = useMemo(() => {

        const total_dict = {}

        const agg_data = aggregateData(['value', 'duration'], data.flatMap(d => {
            total_dict[d.owner_id] = (total_dict[d.owner_id] || 0) + 1
            if (d.status !== 'CONQUERED') return []
            d.duration = (dayjs(d.closed_at).unix() - dayjs(d.created_at).unix()) || 0
            return d
        }), 'owner_id')
        agg_data.forEach(row => {
            row.duration = row.duration / (row.count || 1)
            row.conversion = Math.round((row.count / (total_dict[row.owner_id] || 1)) * 10000) / 100
        })
        return agg_data
    }
        , [data])

    return (
        <>
            {type === 'table' ? <GraphTable rows={graph} columns={[
                { field: 'owner_name', headerName: 'Vendedor', flex: 1, },
                { field: 'count', headerName: 'Quantidade', flex: 1, },
                {
                    field: 'value', headerName: 'Valor', flex: 1,
                    renderCell: ({ value, row }) => `${currencyPrefix[row?.currency]} ${formatCurrency(value*100, row?.currency)}`
                },
                {
                    field: 'duration', headerName: 'Tempo médio de fechamento', flex: 1,
                    renderCell: ({ value }) => convert_seconds(value)
                },
                                {
                    field: 'conversion', headerName: 'Taxa de conversão', flex: 1,
                    renderCell: ({ value }) => `${value} %`
                }
            ]} />
                : <DashView name='closedopportunities' rows={graph} vx='owner_name' vy={['count', 'value', 'duration', 'conversion']} renderValue={(vy, row) => {
                    if (vy === 'value')
                        return `${currencyPrefix[row?.currency]} ${formatCurrency(row[vy]*100, row?.currency)}`
                    else if (vy === 'duration')
                        return convert_seconds(row[vy] / (row.count || 1))
                    else if (vy === 'conversion')
                        return  `${row[vy]} %`
                    return row[vy]
                }}
                />
            }
        </>)
}


export default ClosedOpportunitiesDashboard